import { PredefinedFileterPropertyCodes } from '../core/constantes/predefined-filter-property-codes';
import { AttributeFilters } from './attribute-filters';
import { ICopyable } from './core/copyable.interface';

export class PredefinedFilter implements ICopyable<PredefinedFilter> {
    /** Id du filtre. */
    id: number = null;
    /** id de l'organisation pour laquelle ce filtre s'applique. */
    organizationId: string = null;
    /** id de la vue sur laquelle s'applique le filtre. */
    viewId: number = null;
    /** Nom du filtre */
    name: string = null;
    /** Valeur indiquant si le filtre est partagé entre les utilisateurs de l'organisation. */
    shared: boolean = false;
    /** Id du propriétaire du filtre */
    ownerId: string = null;
    /** Valeur du texte à rechercher. */
    public searchTerm: string = null;
    /** Liste des attributs à filtrer */
    public filteredAttributes: AttributeFilters = new AttributeFilters();

    public constructor() {}

    /**
     * Instancie une instance de FolderListContext
     * @param other : Representation JSON du FolderListContext
     * @returns une instance de FolderListContext
     */
    public static from(other: any) {
        if (!!other) {
            const instance = new PredefinedFilter();
            instance.id = other.id;
            instance.organizationId = other.organizationId;
            instance.viewId = other.viewId;
            instance.name = other.name;
            instance.shared = other.shared;
            instance.ownerId = other.ownerId;
            instance.searchTerm = other.searchTerm;
            instance.filteredAttributes = AttributeFilters.from(other.filteredAttributes);
            return instance;
        } else {
            return null;
        }
    }

    public copyFrom(other: any) {
        if (!!other) {
            this.id = other.id;
            this.name = other.name;
            this.organizationId = other.organizationId;
            this.viewId = other.viewId;
            this.shared = other.shared;
            this.ownerId = other.ownerId;
            this.searchTerm = other.searchTerm;

            this.filteredAttributes = new AttributeFilters();
            this.filteredAttributes.copyFrom(other.filteredAttributes);
        }
    }

    public createCopy(): PredefinedFilter {
        const instance = new PredefinedFilter();
        instance.id = this.id;
        instance.name = this.name;
        instance.organizationId = this.organizationId;
        instance.viewId = this.viewId;
        instance.shared = this.shared;
        instance.ownerId = this.ownerId;
        instance.searchTerm = this.searchTerm;
        instance.filteredAttributes = AttributeFilters.from(this.filteredAttributes);

        return instance;
    }

    public toServerRepresentation() {
        let instance = new Object();
        instance[PredefinedFileterPropertyCodes.ID] = this.id;
        instance[PredefinedFileterPropertyCodes.NAME] = this.name;
        instance[PredefinedFileterPropertyCodes.ORGANIZATION_ID] = this.organizationId;
        instance[PredefinedFileterPropertyCodes.VIEW_ID] = this.viewId;
        instance[PredefinedFileterPropertyCodes.SHARED] = this.shared;
        instance[PredefinedFileterPropertyCodes.OWNER_ID] = this.ownerId;
        instance[PredefinedFileterPropertyCodes.SEARCH_TERM] = this.searchTerm;

        let filteredAttributes = new Object();

        this.filteredAttributes.getKeys().forEach((key) => {
            filteredAttributes[key] = this.filteredAttributes.get(key);
        });

        instance[PredefinedFileterPropertyCodes.FILTERED_ATTRIBUTES] = filteredAttributes;

        return instance;
    }
}
